import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
 
import { Link, useLocation } from 'react-router-dom';
import './CartButton.scss'; // Import CSS for styling
import { IoBagOutline } from 'react-icons/io5';

const CartButton = () => {
    const cartItems = useSelector(state => state.cart.cartItems);
    
 
 
    const location = useLocation();

    const shouldShowButton = cartItems !== 0 && location.pathname !== '/cart';


    return (
        <>
            {shouldShowButton && (
                <Link to="/cart" className="cart-button text-decoration-none">
                    <div className='d-flex gap-2 justify-content-center align-item-center'>
                        <IoBagOutline />
                        <span className=""><strong>{cartItems}</strong> item in cart</span>
                    </div>
                    <p>Go to Cart</p>
                </Link>
            )}
        </>
    );
};

export default CartButton;
